import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';
import { IonItem, IonList, PopoverController } from '@ionic/angular/standalone';

import { ActiveEndpoint } from '@app/interfaces/active-endpoint.interface';
import { EndpointGroupsInterface } from '@app/interfaces/endpoint-groups.interface';

@Component({
  selector: 'app-select-active-endpoint',
  templateUrl: 'select-active-endpoint.component.html',
  styleUrls: ['./select-active-endpoint.component.scss'],
  imports: [IonList, IonItem],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectActiveEndpointComponent {
  private popoverCtrl = inject(PopoverController);

  endpointGroups = input<ActiveEndpoint[]>([]);
  activeEndpoint = input<EndpointGroupsInterface>();

  async selectItem(item: ActiveEndpoint) {
    await this.popoverCtrl.dismiss(item);
  }
}
